import {
    useEffect,
    useState,
} from "react";

import {
    getCropTypes,
    getCropVarieties,
} from "../api/userRegistration";

export default function useCropRegistration({
    cropType,
}) {
    const [
        cropTypes,
        setCropTypes,
    ] = useState([]);

    const [
        cropVarieties,
        setCropVarieties,
    ] = useState([]);

    useEffect(() => {
        const loadCropTypes =
            async () => {
                const types =
                    await getCropTypes();

                setCropTypes(
                    types || []
                );
            };

        loadCropTypes();
    }, []);

    useEffect(() => {
        if (!cropType) {
            setCropVarieties(
                []
            );

            return;
        }

        const loadCropVarieties =
            async () => {
                const varieties =
                    await getCropVarieties(
                        cropType
                    );

                setCropVarieties(
                    varieties || []
                );
            };

        loadCropVarieties();
    }, [cropType]);

    return {
        cropTypes,
        cropVarieties,
    };
}